import React from 'react';
import { observer } from 'mobx-react';
import { DefaultRoute, withRouter } from 'react-router-dom'
import { withApollo } from "react-apollo";
import PageTitle from "../../components/PageTitle";
import TabsComponent from "../../components/fields/TabsComponent";
import TabsData from "../../layout/TabsData";
import PageTitleRightModal from "../../components/PageTitleRightModal";
import PropsUtil from "../../util/PropsUtil";
import InfoBlock from "../../components/InfoBlock";
import util from '../../util/Util'
import BaseForm from "../base/BaseForm";
import UserModel from "../../models/UserModel";
import HistoryComponent from "../../components/HistoryComponent";
import withTranslate from "../../translator/withTranslate";


@observer
class UserHistory extends BaseForm {
    nameMainType = "user";

    constructor(props) {
        super(props);
        this.tabsData = new TabsData();
        this.nameMainType = "user";
        this.initializeGraphData(this.nameMainType);
    }

    getModelQuery() {
        return new UserModel();
    }

    render() {
        console.log("userHistory render =>");
        this.propsUtil = new PropsUtil(this.props);
        let modalClasses = util.getModalClasses();
        const { t, i18n } = this.props;

        return (
            <div className={this.props.fromRightModal ? modalClasses.push : ""}>
                <InfoBlock componentObject={this}>

                    {this.props.fromRightModal ?

                        <div className={modalClasses.head}>
                            <PageTitleRightModal
                                title={t("Usuario")}
                                subtitle={t("Histórico")}
                                mode={"view"}
                                onCloseModal={() => this.onCloseModal()}
                            />
                            <TabsComponent
                                id={this.getFormId()}
                                tabs={this.tabsData.getDataUser()}
                                active={"Histórico"}
                                fromRightModal={this.props.fromRightModal}
                            />
                        </div>
                        :
                        <PageTitle
                            title={t("Usuario")}
                            subtitle={t("Histórico")}
                        />
                    }

                    <div className="card mb-3">
                        {!this.props.fromRightModal &&
                        <TabsComponent
                            id={this.getFormId()}
                            tabs={this.tabsData.getDataUser()}
                            active={"Histórico"}
                        />
                        }
                        <div className="card-body">
                            <HistoryComponent
                                id={this.getFormId()}
                                modelo={this.getModelQuery()}
                            />


                        </div>

                    </div>
                </InfoBlock>
            </div>
        );
    }

}

export default withRouter(withApollo(withTranslate(UserHistory)));
